export default __webpack_public_path__ + "static/media/CA.b7f8c217.svg";